import React from 'react';

const DelayValue = (props) => {
    const { className, delay, total } = props;

    return (
        <div className={`${className}`}>
            <p><text className="h4">{delay}</text> pengiriman delay dari total {total} pengiriman</p>
        </div>
    );
};

export default DelayValue;
